import { combineReducers } from 'redux-immutable';

import toastMessagesReducer from '@Containers/ToastMessages/ToastMessagesReducer';
import { toastMessagesReducerKey } from '@Containers/ToastMessages/ToastMessagesConstants';

import dialogsReducer from '@Containers/Dialogs/DialogsReducer';
import { dialogsReducerKey } from '@Containers/Dialogs/DialogsConstants';

import { stateParamsReducerKey } from '@Constants/StateParamsConstants';

import { key as stateCurrentReducerKey } from '@Constants/StateCurrent';

import { structureFilterReducer } from '@Containers/ResultsFilters/ResultsFiltersComponents/StructureFilter/StructureFilterReducer';
import { structureFilterReducerKey } from '@Containers/ResultsFilters/ResultsFiltersComponents/StructureFilter/StructureFilterConstants';

import searchProgressModalReducer from '@Containers/Search/Shared/SearchProgress/SearchProgressModalReducer';
import { searchProgressModalReducerKey } from '@Containers/Search/Shared/SearchProgress/SearchProgressModalConstants';

import saveFormModalReducer from '@Containers/SaveFormModal/SaveFormModalReducer';
import { saveFormModalReducerKey } from '@Containers/SaveFormModal/SaveFormModalConstants';

import molecularModalReducer from '@Containers/MolecularModal/MolecularModalReducer';
import { molecularModalReducerKey } from '@Containers/MolecularModal/MolecularModalConstants';

import structureOptionsReducer from '@Containers/StructureOptions/StructureOptionsReducer';
import { structureOptionsReducerKey } from '@Containers/StructureOptions/StructureOptionsConstants';

import relativeContextReducer from '@Containers/RelativeContext/RelativeContextReducer';
import { relativeContextReducerKey } from '@Containers/RelativeContext/RelativeContextConstants';

import userDetailsReducer from '@Containers/UserDetails/UserDetailsReducer';
import { userDetailsReducerKey } from '@Containers/UserDetails/UserDetailsConstants';

import sortingPropertiesReducer from '@Containers/SortingProperties/SortingPropertiesReducer';
import { sortingPropertiesReducerKey } from '@Containers/SortingProperties/SortingPropertiesConstants';

import {
  reducer as rcsSupplierInfoReducer,
  reducerKey as rcsSupplierInfoReducerKey,
} from '@Containers/RcsSupplierInfo/RcsSupplierInfoReducer';

import hopintoReducer from '@Containers/Hopinto/HopintoReducer';
import { hopintoReducerKey } from '@Containers/Hopinto/HopintoConstants';

import retroSynthesisProjectsReducer from '@Pages/RetroSynthesis/RetroSynthesisProjects/reducer';
import projectParametersDialogReducer from '@Pages/RetroSynthesis/ProjectParametersDialog/reducer';
import similarSearchReducer from '@Pages/RetroSynthesis/SimilaritySearch/reducer';
import projectRoutesReducer from '@Pages/RetroSynthesis/ProjectRoutes/reducer';
import projectRouteReducer from '@Pages/RetroSynthesis/ProjectRoute/reducer';
import exportReducer from '@Pages/RetroSynthesis/ExportRoute/reducer';
import addStepsReducer from '@Pages/RetroSynthesis/EditPlan/AddSteps/reducer';
import structureOptionReducer from '@Pages/RetroSynthesis/StructureOption/reducer';
import rsBreadcrumbsReducer from '@Pages/RetroSynthesis/RsBreadcrumbs/reducer';
import rsDrawStructureReducer from '@Pages/RetroSynthesis/DrawStructure/reducer';
import rsMultiStepReactionDialogReducer from '@Pages/RetroSynthesis/MultiStepReactionDialog/reducer';
import linkOptionsReducer from '@Pages/RetroSynthesis/LinkOption/reducer';
import slidableReducer from '@Pages/RetroSynthesis/components/RsSlidablePaginated/reducer';
import findPreparationsSimilaritySearchReducer from '@Containers/FindPreparations/SimilatiySearch/reducer';
import resultsReducer from '@Pages/Results/reducer';
import heatmapReducer from '@Pages/Heatmap/reducer';
import historyReducer from '@Pages/History/HistoryReducer';
import resultsPreviewReducer from '@Containers/ResultsPreview/reducer';
import patentFamilyClusteringReducer from '@Containers/PatentFamilyClustering/reducer';
import { historyReducerKey } from '@Pages/History/Constants';

import { REDUCER_KEY_PROJECT_LIST, REDUCER_KEY_RS } from '@Pages/RetroSynthesis/RetroSynthesisProjects/constants';
import { REDUCER_KEY_PROJECT_CREATION_DIALOG } from '@Pages/RetroSynthesis/ProjectParametersDialog/constants';
import { REDUCER_KEY_SIMILARITY_SEARCH } from '@Pages/RetroSynthesis/SimilaritySearch/constants';
import { REDUCER_KEY_PROJECT_ROUTES } from '@Pages/RetroSynthesis/ProjectRoutes/constants';
import { REDUCER_KEY_PROJECT_ROUTE } from '@Pages/RetroSynthesis/ProjectRoute/constants';
import { REDUCER_KEY_RS_EXPORT } from '@Pages/RetroSynthesis/ExportRoute/constants';
import { REDUCER_KEY_STRUCTURE_OPTIONS } from '@Pages/RetroSynthesis/StructureOption/constants';
import { REDUCER_KEY_RS_BREADCRUMBS } from '@Pages/RetroSynthesis/RsBreadcrumbs/constants';
import { REDUCER_KEY_RS_DRAW_STRUCTURE } from '@Pages/RetroSynthesis/DrawStructure/constants';
import { REDUCER_KEY_MULTISTEP_REACTION_DIALOG } from '@Pages/RetroSynthesis/MultiStepReactionDialog/constants';
import { REDUCER_KEY_LINK_OPTIONS } from '@Pages/RetroSynthesis/LinkOption/constants';
import { REDUCER_KEY_RS_ADD_STEPS } from '@Pages/RetroSynthesis/EditPlan/AddSteps/constants';
import { reducer as rcsResultsReducer, reducerKey as rcsResultsReducerKey } from '@Containers/RcsResults/RcsResultsReducer';
import { REDUCER_KEY_RS_SLIDABLE_PAGINATED } from '@Pages/RetroSynthesis/components/RsSlidablePaginated/constants';
import { REDUCER_KEY_FIND_PREPARATIONS_SIMILARITY_SEARCH } from '@Containers/FindPreparations/SimilatiySearch/constants';
import { REDUCER_KEY_RESULTS } from '@Pages/Results/constants';
import { REDUCER_KEY_HEATMAP } from '@Pages/Heatmap/constants';
import { REDUCER_KEY_RESULTS_PREVIEW } from '@Containers/ResultsPreview/constants';
import { REDUCER_KEY_PATENT_FAMILY_CLUSTERING } from '@Containers/PatentFamilyClustering/constants';

// CAS Number
import { REDUCER_KEY_CAS_NUMBER } from '@Containers/CasNumber/constants';
import casNumberReducer from '@Containers/CasNumber/reducer';
import { reducer as stateCurrentReducer } from './StateCurrentReducer';
import stateParamsReducer from './StateParamsReducer';

import { routesReducerkey } from '../AppRoutes/constants';
import routesReducer from '../AppRoutes/AppRoutesReducer';

export default function createReducer(asyncReducer = {}) {
  return combineReducers({
    [toastMessagesReducerKey]: toastMessagesReducer,
    [stateCurrentReducerKey]: stateCurrentReducer,
    [stateParamsReducerKey]: stateParamsReducer,
    [dialogsReducerKey]: dialogsReducer,
    [structureFilterReducerKey]: structureFilterReducer,
    [structureOptionsReducerKey]: structureOptionsReducer,
    [relativeContextReducerKey]: relativeContextReducer,
    [userDetailsReducerKey]: userDetailsReducer,
    [sortingPropertiesReducerKey]: sortingPropertiesReducer,
    [rcsSupplierInfoReducerKey]: rcsSupplierInfoReducer,
    [hopintoReducerKey]: hopintoReducer,
    [historyReducerKey]: historyReducer,
    [routesReducerkey]: routesReducer,
    [searchProgressModalReducerKey]: searchProgressModalReducer,
    [saveFormModalReducerKey]: saveFormModalReducer,
    [molecularModalReducerKey]: molecularModalReducer,
    [REDUCER_KEY_RS]: combineReducers({
      [REDUCER_KEY_PROJECT_LIST]: retroSynthesisProjectsReducer,
      [REDUCER_KEY_PROJECT_CREATION_DIALOG]: projectParametersDialogReducer,
      [REDUCER_KEY_SIMILARITY_SEARCH]: similarSearchReducer,
      [REDUCER_KEY_PROJECT_ROUTES]: projectRoutesReducer,
      [REDUCER_KEY_PROJECT_ROUTE]: projectRouteReducer,
      [REDUCER_KEY_RS_EXPORT]: exportReducer,
      [REDUCER_KEY_RS_ADD_STEPS]: addStepsReducer,
      [REDUCER_KEY_RS_SLIDABLE_PAGINATED]: slidableReducer,
      [REDUCER_KEY_STRUCTURE_OPTIONS]: structureOptionReducer,
      [REDUCER_KEY_RS_BREADCRUMBS]: rsBreadcrumbsReducer,
      [REDUCER_KEY_RS_DRAW_STRUCTURE]: rsDrawStructureReducer,
      [REDUCER_KEY_MULTISTEP_REACTION_DIALOG]: rsMultiStepReactionDialogReducer,
      [REDUCER_KEY_LINK_OPTIONS]: linkOptionsReducer,
    }),
    [rcsResultsReducerKey]: rcsResultsReducer,
    [REDUCER_KEY_CAS_NUMBER]: casNumberReducer,
    [REDUCER_KEY_FIND_PREPARATIONS_SIMILARITY_SEARCH]: findPreparationsSimilaritySearchReducer,
    [REDUCER_KEY_RESULTS]: resultsReducer,
    [REDUCER_KEY_HEATMAP]: heatmapReducer,
    [REDUCER_KEY_RESULTS_PREVIEW]: resultsPreviewReducer,
    [REDUCER_KEY_PATENT_FAMILY_CLUSTERING]: patentFamilyClusteringReducer,
    ...asyncReducer,
  });
}
